import { GraphQLClient } from 'graphql-request';
import { GRAPHQL_API_URL } from './config';
import { getCompanyUid, getTokenFromCookies, getSsoForced } from './globals';
import { getSdk } from '../types/grappa';
function getHeaders() {
    const token = getTokenFromCookies();
    return {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...(getSsoForced() ? { 'sso-forced': 'true' } : {}),
        'company-uid': getCompanyUid(),
    };
}
async function query(queryString, variables, controller) {
    const graphQLClient = new GraphQLClient(GRAPHQL_API_URL, {
        headers: getHeaders(),
        // @ts-ignore
        signal: controller ? controller.signal : undefined,
    });
    const data = await graphQLClient.request(queryString, variables);
    return data;
}
export default query;
export function sdk({ controller, } = {}) {
    const graphQLClient = new GraphQLClient(GRAPHQL_API_URL, {
        headers: getHeaders(),
        // @ts-ignore
        signal: controller ? controller.signal : undefined,
    });
    return getSdk(graphQLClient);
}
//# sourceMappingURL=grappa.js.map